module.exports = __webpack_public_path__ + "a43efce722dcfbe445c23da76f5fcb47.png";